import { EBaseButtonSize, EBaseButtonType } from '@spinwise/react-component-library/ButtonAbstract';
import React from 'react';
import { IconLibrary } from 'Libraries/icons.library';
import styles from './OverlayHeader.module.scss';
import { EBrandTextColor } from 'Libraries/typography.library';
import { IconVariantsLibrary } from 'Libraries/variants.library';
import { ButtonIconOnly } from '@spinwise/react-component-library/ButtonIconOnly';
import { BaseText, EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { BaseDivider, EBaseDividerSize } from '@spinwise/react-component-library/BaseDivider';

export interface IOverlayHeaderProps {
  hasStepBack: boolean;
  title: string;
  onClickBack?: () => void;
  onClickClose?: () => void;
}

const OverlayHeader = ({ title, hasStepBack, onClickBack, onClickClose }: IOverlayHeaderProps) => {
  const onClickBackHandler = () => {
    onClickBack();
  };
  const onClickCloseHandler = () => {
    onClickClose();
  };

  return (
    <>
      <div className={`${styles.overlay_container__top} d-fl jc-sb ai-c`}>
        <div className={`d-fl ai-c`}>
          {hasStepBack == true && (
            <ButtonIconOnly
              onClick={onClickBackHandler}
              size={EBaseButtonSize.Medium}
              type={EBaseButtonType.None}
              iconName={IconLibrary.ArrowLeftLong}
            />
          )}
          <div className="title">
            <BaseText
              value={title}
              size={EBaseTextSize.Regular}
              weight={EBaseTextWeight.W400}
              color={EBrandTextColor.Black04}
            />
          </div>
        </div>
        <div className="top--right">
          <ButtonIconOnly
            onClick={onClickCloseHandler}
            size={EBaseButtonSize.Medium}
            type={EBaseButtonType.None}
            iconName={IconLibrary.CrossSm}
            variant={IconVariantsLibrary.Black04}
          ></ButtonIconOnly>
        </div>
      </div>
      <BaseDivider size={EBaseDividerSize.FullWidth} />
    </>
  );
};

export default OverlayHeader;
